import { makeStyles } from "@material-ui/core";

import CharacterImage from "assets/images/hero-unit/character.png";
import ConfettiImage from "assets/images/hero-unit/confetti.png";
import ConfettiTabletImage from "assets/images/hero-unit/confetti-tablet.png";

export default makeStyles(
  (theme) => ({
    root: {
      backgroundColor: theme.palette.cornflowerBlue,
      backgroundImage: `url(${CharacterImage}), url(${ConfettiImage})`,
      backgroundSize: "75%, cover",
      backgroundRepeat: "no-repeat, no-repeat",
      backgroundPosition: "right bottom, center",
      [theme.breakpoints.up("mobile")]: {
        backgroundImage: `url(${CharacterImage}), url(${ConfettiTabletImage})`,
        backgroundPosition: "65%, center",
        backgroundSize: "contain, cover",
      },
    },
    content: {
      padding: "1.4rem 0 2rem",
      [theme.breakpoints.up("mobile")]: {
        padding: "4rem 0 6rem 4.5rem",
      },
      [theme.breakpoints.up("tablet")]: {
        padding: "4rem 0 6rem 5rem",
      },
    },
    label: {
      fontSize: "1.2rem",
      marginBottom: 5,
      color: theme.palette.common.white,
      [theme.breakpoints.up("mobile")]: {
        fontSize: "1.7rem",
        marginBottom: 9,
      },
      [theme.breakpoints.up("tablet")]: {
        fontSize: "2.5rem",
        marginBottom: 15,
      },
    },
    tagline: {
      color: theme.palette.common.white,
      fontSize: "2.3rem",
      fontWeight: 800,
      lineHeight: "41px",
      letterSpacing: 1,
      marginBottom: 15,
      [theme.breakpoints.up("mobile")]: {
        letterSpacing: 1.8,
        fontSize: "2.8rem",
        lineHeight: "3rem",
      },
      [theme.breakpoints.up("tablet")]: {
        fontSize: "4.6rem",
        lineHeight: "4.5rem",
        marginBottom: 34,
      },
    },
    button: {
      width: "auto",
      height: "auto",
      padding: "2px 18px 0",
      fontSize: ".7rem",
      lineHeight: "49px",
      color: "#222e40",
      backgroundColor: "#5fe0df",
      border: "none",
      cursor: "pointer",
      boxShadow: "0 3px 6px transparent, 0 3px 6px transparent",
      transition: "box-shadow .4s cubic-bezier(.25,.8,.25,1),transform .4s cubic-bezier(.25,.8,.25,1)",
      borderRadius: 100,
      "&:hover": {
        backgroundColor: "#5fe0df",
        color: theme.palette.common.white,
        transform: "scale(1.1)",
      },
      [theme.breakpoints.up("mobile")]: {
        padding: "3px 23px 0",
        fontSize: "1rem",
        lineHeight: "56px",
      },
      [theme.breakpoints.up("tablet")]: {
        padding: "3px 66px 0",
        fontSize: "1.6rem",
        lineHeight: "74px",
      },
    },
  }),
  { name: "Hero" },
);
